import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "side-panel-container" }
const _hoisted_2 = { class: "side-panel-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["side-panel", _ctx.sidePanelClasses])
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(["side-panel-button bi", [_ctx.icon]]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx._open = !_ctx._open))
    }, null, 2),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 2))
}